// Runtime configuration utility
// Reads from window.APP_CONFIG (set by config.js) or falls back to build-time env vars

declare global {
  interface Window {
    APP_CONFIG?: {
      VITE_ENV: string;
      VITE_API_URL: string;
      VITE_IDENTITY_API_URL: string;
      VITE_STRIPE_PUBLISHABLE_KEY: string;
    };
  }
}

const getConfig = () => {
  // Try runtime config first (from config.js)
  if (typeof window !== "undefined" && window.APP_CONFIG) {
    return window.APP_CONFIG;
  }

  // Fall back to build-time environment variables
  return {
    VITE_ENV: import.meta.env.VITE_ENV || "development",
    VITE_API_URL: import.meta.env.VITE_API_URL || "",
    VITE_IDENTITY_API_URL: import.meta.env.VITE_IDENTITY_API_URL || "",
    VITE_STRIPE_PUBLISHABLE_KEY:
      import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "",
  };
};

export const config = getConfig();
